import WidgetComponent from "./src/components/SimpleWidgetComponent";
import localConfig from "./widgetAssets/config.json";

const App = ({ map, mapView, locationSearchUrl, locationSearchProxyUrl }) => {
  const resolvedLocationSearchUrl =
    locationSearchUrl || localConfig.locationSearchURL;

  const finalLocationSearchUrl = locationSearchProxyUrl
    ? `${locationSearchProxyUrl}${resolvedLocationSearchUrl}`
    : resolvedLocationSearchUrl;

  return (
    <WidgetComponent
      map={map}
      mapView={mapView}
      minDigits={3}
      minScale={2000}
      placeholder={"Orts- und Adresssuche"}
      locationSearchURL={finalLocationSearchUrl}
    />
  );
};

export default App;
